// src/components/ProtectedRoute.jsx
import { useAuth } from '../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading, authStatus, user } = useAuth();
  const location = useLocation();

  if (loading || authStatus === 'loading') {
    return (
      <Box sx={{ height: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Forzar cambio de contraseña en ruta neutral
  const pwChangeRoute = '/account/password';
  const isAllowed = location.pathname.startsWith(pwChangeRoute);
  if (user?.require_password_change && !isAllowed) {
    return <Navigate to={`${pwChangeRoute}?first=1`} replace />;
  }

  return children;
}
